import RYBConnectClasses from "../../common/services/classes.service";
import { APP_VERSION, DEFAULT_CATEGORY } from "../../common/services/default-category.service";
import { trackingService } from "../../common/services/tracking.service";
import { ALLOWED_FILTER_KEYS, URL_PARAMETERS } from "../../common/utils/const.util";
import { handleUnexpectedError } from "../../common/utils/errors.util";
import { getUrlParameterValue, setUrlParameter } from "../../common/utils/url.util";
import { processResult } from "../finder/services/result.service";
import { ChildService } from "./services/child.service";
import { ClassesService } from "./services/classes.service";
import { ParentService } from "./services/parent.service";
import { getCookie } from "../campaign";
declare global {
  interface Window {
    google: typeof google;
    initMap: () => void;
  }
}
$(async () => {
  try {
    const dataManager = new RYBConnectClasses();
    console.log(`RYB Connect ${APP_VERSION}`);

    const currentStep = getUrlParameterValue(URL_PARAMETERS.STEP) || "0";
    trackingService.pushEvent("ryb_page_view", { step: currentStep });
    
    const isNewCamps = !!document.querySelector("#class-finder.template-new-camps");
    const savedFilters = getCookie("rybFilters");
    const hasSubmittedLead = !!getCookie("rybUser");
    const isResultStep = getUrlParameterValue(URL_PARAMETERS.STEP) === "3";
    const canSkipNewCamps = !isNewCamps || hasSubmittedLead;

    // Validate saved filters have at least one meaningful filter key
    // (not just "user" or "contact" which don't filter classes)
    const meaningfulFilterKeys = new Set(["age", "gender", "location", "classtype", "category", "days", "session"]);
    let hasMeaningfulFilters = false;
    if (savedFilters) {
      try {
        const parsed = JSON.parse(atob(savedFilters));
        hasMeaningfulFilters = Object.keys(parsed).some((k) => meaningfulFilterKeys.has(k) && parsed[k]);
      } catch {
        hasMeaningfulFilters = false;
      }
    }

    if (savedFilters && hasMeaningfulFilters && !isResultStep && canSkipNewCamps) {
      $(".wizard-stage").removeClass("active");
      $(".step-loading").addClass("active");
      const filters = JSON.parse(atob(savedFilters));
      // Migrate legacy "category" key → "classtype" for users with old saved filters
      if (filters.category && !filters.classtype) {
        filters.classtype = filters.category;
        delete filters.category;
      }
      // Migrate Jackrabbit-style "Cat<N>" key (where N matches the site's
      // configured DEFAULT_CATEGORY) → "classtype". This rescues users whose
      // cookies got polluted with `Cat2=Rattlers` from registration links —
      // their filter intent is preserved instead of dropped.
      const catNumber = DEFAULT_CATEGORY.replace("category", "");
      const jackrabbitKey = `Cat${catNumber}`;
      if (filters[jackrabbitKey] && !filters[URL_PARAMETERS.CATEGORY]) {
        filters[URL_PARAMETERS.CATEGORY] = filters[jackrabbitKey];
      }
      delete filters.Cat1;
      delete filters.Cat2;
      delete filters.Cat3;
      // Drop any remaining cookie keys that aren't recognized filter
      // dimensions (utm_*, random share-link junk, etc.).
      Object.keys(filters).forEach((key) => {
        if (!ALLOWED_FILTER_KEYS.has(key)) {
          delete filters[key];
        }
      });
      Object.entries(filters).forEach(([key, value]) => {
        setUrlParameter(key as any, value as string);
      });
      setUrlParameter(URL_PARAMETERS.STEP, "3");
      setUrlParameter(URL_PARAMETERS.FUNNEL_SKIP, "true");
      $("#ryb-openings-result").addClass("show");
      $(".step-view.result").show();

      if (isNewCamps) {
        return;
      }

      const result = await dataManager.getData();
      if (result) {
        processResult();
        $(".step-loading").removeClass("active");
      }
      return;
    }
    
    ParentService.addEventListeners();

    if (isNewCamps) {
      // New-camps uses Camp Listings API (loaded by templates bundle),
      // so skip Jackrabbit Classes API fetch and class-dependent services
      await ChildService.addEventListeners();
      $(".step-loading").removeClass("active");
    } else {
      const result = await dataManager.getData();
      await ChildService.addEventListeners();
      await ClassesService.addEventListener();
      const isCalendarShortcode = document.querySelector(
        `#ryb-connect[data-shortcode-type="finder"]`
      );
      if (isResultStep || isCalendarShortcode) {
        processResult();
      }

      if (result) {
        $(".step-loading").removeClass("active");
      }
    }
  } catch (error) {
    console.error("Error initializing wizard:", error);
    handleUnexpectedError("", "", error);
  }
});
